import PropTypes from 'prop-types';
import {map as _map} from 'lodash';

import {getYesOrNo} from '@utils/helpers';
import {getSlaThresholdForExcel} from '@utils/sla/slaThreshold';
import {sortByTextValue} from '@utils/sorters';

export const exportExcel = (dataExport, clientId) => ({
    dataExport: dataExport,
    filename: `client_${clientId}_packages`,
    parseData: clientPackage => [
        clientPackage.id,
        clientPackage.client_product.product.short_name,
        clientPackage.name,
        clientPackage.client_package_type.name,
        clientPackage.booking_type.name,
        sortByTextValue(clientPackage.content_package_types, 'name')
            .map(contentPackageType => contentPackageType.name).join(', '),
        _map(clientPackage.event_content_variants, (eventContentVariant) => eventContentVariant.name).join(', '),
        clientPackage.start_date,
        clientPackage.end_date,
        0 < clientPackage.client_package_geo_restrictions.length
            ? 'Specific'
            : 'Same as client product settings',
        getYesOrNo(clientPackage.is_hq),
        getYesOrNo(clientPackage.is_ll),
        getYesOrNo(clientPackage.is_test),
        getSlaThresholdForExcel(clientPackage),
        getYesOrNo(clientPackage.is_disabled),
    ],
    path: 'clients.packages.index.path',
    titles: [
        'ID',
        'Product',
        'Name',
        'Type',
        'Booking',
        'Content selection',
        'Content variants',
        'Start date',
        'End date',
        'Geo restrictions',
        'High Quality?',
        'Low Latency?',
        'Test?',
        'SLA',
        'Disabled?',
    ],
});

exportExcel.propTypes = {
    clientId: PropTypes.number.isRequired,
    dataExport: PropTypes.array.isRequired,
};
